import asignedPinGreen from 'assets/images/asigned-pin-green.png';
import asignedPin from 'assets/images/asigned-pin.png';
import boxPin from 'assets/images/box-pin.png';
import defaultPin from 'assets/images/defaultPinIcon.png';
import searchPinIconImg from 'assets/images/search-pin.png';
import L from 'leaflet';

const podoPinImg = process.env.PUBLIC_URL + '/podo.png';

export const carPinIcon = L.icon({
  iconUrl: asignedPin,
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -30],
});

export const greenCarPinIcon = L.icon({
  iconUrl: asignedPinGreen,
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -30],
});

export const boxPinIcon = L.icon({
  iconUrl: boxPin,
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -30],
});

export const defaultPinIcon = L.icon({
  iconUrl: defaultPin,
  iconSize: [24, 32],
  iconAnchor: [12, 32],
  shadowSize: [24, 32],
  shadowAnchor: [12, 32],
  popupAnchor: [0, -30],
});

export const searchPinIcon = L.icon({
  iconUrl: searchPinIconImg,
  iconSize: [24, 32],
  iconAnchor: [12, 32],
  shadowSize: [24, 32],
  shadowAnchor: [12, 32],
  popupAnchor: [0, -30],
});

export const podoPinIcon = L.icon({
  iconUrl: podoPinImg,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
  className: 'bg-white shadow-md rounded-full',
});
